module.exports = __webpack_public_path__ + "media/Diagnose Clarissa_neu_Stufe01.d1468660.mp4";